export default __webpack_public_path__ + "static/media/Runoff.27825e36.webm";